<div class="modal-background">
  <div class="modal fade show" style="display: block;" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">1.Seleccione los Listados donde Aparecera</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="eventos.Closing()" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div color="dark">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-12">
                  <div class="card bg-dark text-light p-2">
                  
                    <div>
                      <h5>Listados Disponibles</h5>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="defaultCheck1" value="Lista General"
                        [(ngModel)]="value1" (change)="setlistado($event.target.value)">
                      <label class="form-check-label" for="defaultCheck1">
                        Lista General
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="defaultCheck1" value="disponible"
                        [(ngModel)]="value2" (change)="setlistado($event.target.value)">
                      <label class="form-check-label" for="defaultCheck1">
                        Disponible
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="defaultCheck1" value="Premium"
                        [(ngModel)]="value3" (change)="setlistado($event.target.value)">
                      <label class="form-check-label" for="defaultCheck1">
                        Premium
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="defaultCheck1" value="V.I.P"
                        [(ngModel)]="value4" (change)="setlistado($event.target.value)">
                      <label class="form-check-label" for="defaultCheck1">
                        V.I.P
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="defaultCheck1" value="PROMO"
                        [(ngModel)]="value5" (change)="setlistado($event.target.value)">
                      <label class="form-check-label" for="defaultCheck1">
                        PROMO
                      </label>
                    </div>
                  </div>
  
                </div>
  
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="card bg-dark text-light">
                    <div>
                      <h5>2.Defina la Imagen a utilizar en los Listados Seleccionados</h5>
                    </div>
                    <div class="p-2">
                      <div class="container-fluid">
                        <div class="row">
                          <div class="col-sm-6">
                            <h5>Imagenes Seleccionada</h5>
                          </div>
                          <div class="col-sm-6">
                            <div class="p-4 text-right">
                              <button class="btn btn-primary m-1" (click)="save()"
                                [disabled]="!profileImage && listados.length == 0">
                                Guardar Cambios
                              </button>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="d-flex flex-column justify-content-between align-items-start">
                              <div class="d-flex flex-row flex-wrap ">
                                <div class="card" style="max-width: 200px;" color="primary" *ngIf="profileImage">
                                  <button class="btn btn-danger btn-circle btn-sm" type="button" aria-label="Close"
                                    (click)="quitarImagen()">
                                    <span aria-hidden="true">
                                      <i class="fas fa-trash"></i>
                                    </span>
                                  </button>
                                  <img [src]="profileImage | imagen:'profile'" class="img-fluid z-depth-1"
                                    alt="Responsive image">
                                </div>
                              </div>
                            </div>
                          </div>
  
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <h5>Seleccione la imagen para sus listado</h5>
                          </div>
                          <div class="col-sm-12">
                            <div class="d-flex flex-column justify-content-between align-items-end">
                              <div class="d-flex flex-row flex-wrap justify-content-around ">
                                <div class="card m-1" *ngFor="let i of imagenes" style="max-width: 200px;">
                                  <button class="btn btn-success btn-circle btn-sm" (click)="addImagen(i)"
                                    style="z-index: 1550;">
                                    <i class="fas fa-plus-circle"></i>
                                  </button>
                                  <img [src]="i | imagen:'profile'" class="img-fluid" alt="Responsive image">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
   
      </div>
    </div>
  </div>
</div>

<app-modal-loading [show]="modal_loading"></app-modal-loading>